import { useFeatureIsOn } from '@growthbook/growthbook-react';

/**
 * GrowthBook flag that gates the Wellhub × Urban Sports Club co-branded flow.
 *
 * The flag targets the `country_code` attribute, which is seeded from the
 * browser-inferred country at init and overridden by the user's selected
 * country (see `useCountryChange`). The flag therefore prioritises the
 * selected country and falls back to the browser country with no extra logic
 * on the consumer side.
 */
export const WELLHUB_USC_FLOW_FLAG =
  'partners.acquisition.wellhub-usc-flow' as const;

/**
 * Whether the current prospect is in the Wellhub × Urban Sports Club flow
 * (i.e. located in a USC territory per the {@link WELLHUB_USC_FLOW_FLAG}).
 *
 * Shared across the features that build on this flow, all read post-lead
 * creation where Country is already settled; consumers should read it through
 * this hook rather than calling `useFeatureIsOn` with the raw key.
 */
export function useUscWellhubFlow(): boolean {
  return useFeatureIsOn(WELLHUB_USC_FLOW_FLAG);
}
